import { BlockFlow } from '@components/Modals/Variants/BlockFlow/BlockFlow';
import { ReportFlow } from '@components/Modals/Variants/ReportFlow/ReportFlow';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useGetIsBlocked } from '@hooks/TRPC_Hooks/useGetIsBlocked';
import { useOnClickOutside } from '@hooks/useClickOutside';
import { useShowToast } from '@hooks/useShowToast';
import { useTranslation } from '@hooks/useTranslation';
import { copyHandler } from '@specs/helpers';
import { getRtoystUrl, LinksEnum } from '@specs/navigation';
import { SocialManagerView } from '@specs/views';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { FC, memo, useRef, useState } from 'react';
import s from './actions.module.scss';
import { useGetIsBlockedBy } from '@hooks/TRPC_Hooks/useGetIsBlockedBy';
import { ConditionWrapper } from '@components/UIKit/ConditionWrapper/ConditionWrapper';
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
  isMyProfile: boolean;
}
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  size: 'medium',
  color: 'Transparent'
};
const ActionsMemo: FC<Props> = ({
  shortid,
  isMyProfile
}) => {
  const actionsRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const {
    showToast
  } = useShowToast();
  const {
    isBlocked
  } = useGetIsBlocked({
    targetShortId: shortid
  });
  const {
    isBlocked: isBlockedBy
  } = useGetIsBlockedBy({
    targetShortId: shortid
  });
  const isBlock = isBlocked || isBlockedBy;
  const [isActionsOpen, setIsActionsOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isReportFlowOpen, setIsReportFlowOpen] = useState(false);
  const closeActionsHandler = () => setIsActionsOpen(false);
  useOnClickOutside(actionsRef, closeActionsHandler);
  const handleCopy = async () => {
    const link = getRtoystUrl(LinksEnum.USER, shortid);
    await copyHandler(link).then(_ => {
      showToast({
        variant: 'success',
        text: 'link.copied'
      });
    }).catch(_ => {
      showToast({
        variant: 'error'
      });
    });
    closeActionsHandler();
  };
  const isShowBlocking = process.env.NEXT_PUBLIC_IS_SHOW_BLOCKING === 'true';
  return <div className={s.actions} ref={actionsRef} data-sentry-component="ActionsMemo" data-sentry-source-file="Actions.tsx">
            <BlockFlow isOpen={isBlockModalOpen} onClose={() => setIsBlockModalOpen(false)} targetShortId={shortid} data-sentry-element="BlockFlow" data-sentry-source-file="Actions.tsx" />

            <ReportFlow isOpen={isReportFlowOpen} targetShortId={shortid} onClose={() => setIsReportFlowOpen(false)} data-sentry-element="ReportFlow" data-sentry-source-file="Actions.tsx" />

            <SpriteIcon className={s.actions__icon} name='dots' onClick={() => setIsActionsOpen(prev => !prev)} data-sentry-element="SpriteIcon" data-sentry-source-file="Actions.tsx" />

            <div className={cn(s.actions__list, isActionsOpen && s.actions__list_open)}>
                <Button id='default_button' {...defaultButtonProps} onClick={handleCopy} data-sentry-element="Button" data-sentry-source-file="Actions.tsx">
                    {tr({
          id: 'public.profile.copy.link.to.profile'
        })}
                </Button>

                {isMyProfile ? <>
                        {/* Создание постов отключено */}
                        {/* <Button
                            id='default_button'
                            {...defaultButtonProps}
                            onClick={() => router.push(LinksEnum.POST_CREATE)}
                         >
                            {tr({ id: 'btn.new.post' })}
                         </Button> */}
                        <Button id='default_button' {...defaultButtonProps} onClick={() => router.push(LinksEnum.SETTINGS)}>
                            {tr({
            id: 'btn.edit.profile'
          })}
                        </Button>
                    </> : <>
                        {isShowBlocking && <>
                                <ConditionWrapper condition={!isBlock}>
                                    <Button id='default_button' {...defaultButtonProps} onClick={() => setIsReportFlowOpen(true)}>
                                        {tr({
                id: 'btn.report.this.author'
              })}
                                    </Button>
                                </ConditionWrapper>
                                {/* {
                                    !isBlocked && (
                                        <Button
                                            id='default_button'
                                            {...defaultButtonProps}
                                            onClick={() => setIsBlockModalOpen(true)}
                                        >
                                            {tr({ id: 'btn.block.this.author' })}
                                        </Button>
                                    )
                                 } */}
                            </>}
                    </>}
            </div>
        </div>;
};
export const Actions = memo(ActionsMemo);